import { render, staticRenderFns } from "./yVoid.vue?vue&type=template&id=2498ae99&scoped=true&"
import script from "./yVoid.vue?vue&type=script&lang=js&"
export * from "./yVoid.vue?vue&type=script&lang=js&"
import style0 from "./yVoid.vue?vue&type=style&index=0&id=2498ae99&lang=scss&scoped=true&"
import style1 from "./yVoid.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2498ae99",
  null
  
)

export default component.exports